import type { ApiInstructorDetail } from '../types/course'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5050/api'

interface ApiResponse<T> {
  success: boolean
  data: T
  error?: string
}

export const getInstructorById = async (instructorId: number | string): Promise<ApiInstructorDetail> => {
  const res = await fetch(`${API_URL}/instructors/${instructorId}`)
  const json: ApiResponse<ApiInstructorDetail> = await res.json()
  if (!json.success) throw new Error(json.error || 'ไม่พบผู้สอนนี้')
  return json.data
}

// หน้า Home ("เรียนกับผู้เชี่ยวชาญจริง") — ผู้สอนที่มีคอร์สเผยแพร่แล้ว เรียงตามจำนวนผู้เรียนรวมมากไปน้อย
export interface FeaturedInstructor {
  instructor_id: number
  first_name: string
  last_name: string
  avatar_url: string | null
  current_positions: string | null
  rating: number
  students: number
  course_count: number
  expertise: string[]
}

export const getFeaturedInstructors = async (limit = 4): Promise<FeaturedInstructor[]> => {
  const res = await fetch(`${API_URL}/instructors?limit=${limit}`)
  const json: ApiResponse<FeaturedInstructor[]> = await res.json()
  if (!json.success) throw new Error(json.error || 'โหลดข้อมูลผู้สอนไม่สำเร็จ')
  return json.data
}
